/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react/prop-types */
import React from "react";
import {
  makeStyles,
  Card,
  Container,
  CardContent,
  Divider,
  Link
} from "@material-ui/core";
import { Link as NavLink } from "react-router-dom";

import athenaLogo from "resources/logo.png";
import wave from "resources/wave.svg";

const useStyles = makeStyles(theme => ({
  section: {
    backgroundColor: "transparent"
  },
  cardContent: {
    paddingTop: "0px"
  },
  divider: {
    marginTop: "30px",
    marginBottom: "10px"
  },
  header: {
    textAlign: "center",
    paddingTop: "40px",
    paddingBottom: "40px",
    backgroundColor: "#fff"
  },
  logo: {
    width: "200px"
  },
  formButton: {
    marginTop: "20px"
  },
  loginPage: {
    display: "flex",
    flexFlow: "column",
    height: "100%",
    backgroundColor: "#fff",
    backgroundSize: "cover",
    backgroundImage: `url(${wave})`,
    backgroundRepeat: "no-repeat",
    [theme.breakpoints.up("xs")]: {
      backgroundPosition: "bottom"
    },
    [theme.breakpoints.up("sm")]: {
      backgroundPosition: "bottom"
    },
    [theme.breakpoints.up("md")]: {
      backgroundPosition: "bottom"
    },
    [theme.breakpoints.up("lg")]: {
      backgroundPosition: "right"
    },
    [theme.breakpoints.up("xl")]: {
      backgroundPosition: "right"
    }
  },
  linksContainer: {
    display: "flex",
    justifyContent: "space-evenly",
    flexWrap: "wrap",
    "& > *": {
      padding: "0px 5px"
    }
  },
  loginContainer: {
    display: "flex",
    [theme.breakpoints.up("sm")]: {
      paddingLeft: "8px",
      paddingRight: "8px"
    },
    [theme.breakpoints.up("md")]: {
      paddingLeft: "16px",
      paddingRight: "16px"
    },
    [theme.breakpoints.up("lg")]: {
      paddingLeft: "16px",
      paddingRight: "16px"
    }
  },
  loginForm: {
    display: "flex",
    flexDirection: "column",
    width: "400px",
    margin: "0px auto 24px",
    alignItems: "center",

    background: "rgb(255, 255, 255)",
    borderRadius: "3px",
    [theme.breakpoints.up("xs")]: {
      padding: "0px 40px",
      boxShadow: "none"
    },
    [theme.breakpoints.up("sm")]: {
      padding: "32px 40px",
      boxShadow: "rgba(0, 0, 0, 0.1) 0px 0px 10px",
      boxSizing: "border-box"
    },
    [theme.breakpoints.up("md")]: {
      padding: "32px 40px",
      boxShadow: "rgba(0, 0, 0, 0.1) 0px 0px 10px",
      boxSizing: "border-box"
    },
    [theme.breakpoints.up("lg")]: {
      padding: "32px 40px",
      boxShadow: "rgba(0, 0, 0, 0.1) 0px 0px 10px",
      boxSizing: "border-box"
    }
  },
  disclosure: {
    paddingBottom: "20px",
    display: "inherit",
    flexDirection: "inherit",
    alignItems: "inherit"
  }
}));

function LoginComponent({
  children,
  dividerLinkTo,
  dividerLinkText,
  showLinks = true
}) {
  const classes = useStyles();

  return (
    <div className={classes.loginPage}>
      <header className={classes.header}>
        <img
          src={athenaLogo}
          className={classes.logo}
          alt="Athena Login Logo"
        />
      </header>
      <section className={classes.section}>
        <Container
          component="main"
          className={classes.loginContainer}
          maxWidth="xs"
        >
          <Card className={classes.loginForm}>
            <CardContent className={classes.cardContent}>
              {children}
              {showLinks && (
                <>
                  <Divider className={classes.divider} />
                  <div className={classes.linksContainer}>
                    <Link
                      to={dividerLinkTo}
                      component={NavLink}
                      variant="body2"
                    >
                      {dividerLinkText}
                    </Link>
                  </div>
                </>
              )}
            </CardContent>
          </Card>
        </Container>
      </section>
    </div>
  );
}

export default LoginComponent;
